import React from "react";

import Overlay from "../assets/img/overlay.png";

function Sphere(props) {
  return (
    <>
      <div
        className={`w-full h-full mix-blend-lighten absolute ${props.className}`}
        style={{
          background: `url(https://d2bcbbcv6bdckc.cloudfront.net/Balls-Nverse-1080-1920-31.gif) no-repeat scroll center center`,
          backgroundSize: "cover",
          backgroundOrigin: "content-box",
        }}
      />
      <div
        className="w-full h-full mix-blend-color absolute"
        style={{
          background: `url(${Overlay}) no-repeat scroll center center`,
          backgroundSize: "cover",
          backgroundOrigin: "content-box",
        }}
      />
    </>
  );
}

export default Sphere;
